import { z } from 'zod';
import { moneySchema, projectViewSchema } from './current-project';

export const kvnAmountSchema = moneySchema.refine(
  (value) => value !== '0',
  'Enter a positive whole KVN amount (maximum 18446744073709551615).'
);
const timestamp = z.number().int().nonnegative().safe();
export const balanceViewSchema = z.object({
  account: projectViewSchema.shape.client,
  assetId: z.literal(1),
  available: moneySchema,
});
export const depositViewSchema = z
  .object({
    depositId: projectViewSchema.shape.projectId,
    owner: projectViewSchema.shape.client,
    destination: projectViewSchema.shape.client,
    amount: kvnAmountSchema,
    status: z.enum(['Pending', 'Confirmed']),
    createdAt: timestamp,
    confirmedAt: timestamp.nullable(),
  })
  .refine(
    (view) =>
      view.owner === view.destination &&
      (view.status === 'Confirmed') === (view.confirmedAt !== null) &&
      (view.confirmedAt === null || view.confirmedAt >= view.createdAt)
  );
export const withdrawalViewSchema = z
  .object({
    withdrawalId: projectViewSchema.shape.projectId,
    owner: projectViewSchema.shape.client,
    amount: kvnAmountSchema,
    status: z.enum(['Pending', 'Cancelled']),
    createdAt: timestamp,
    cancelledAt: timestamp.nullable(),
  })
  .refine(
    (view) =>
      (view.status === 'Cancelled') === (view.cancelledAt !== null) &&
      (view.cancelledAt === null || view.cancelledAt >= view.createdAt)
  );
export type DepositView = z.infer<typeof depositViewSchema>;
export type WithdrawalView = z.infer<typeof withdrawalViewSchema>;
